export const OG_IMAGE_SIZE = {
  width: 1200,
  height: 630,
} as const;
